import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {ToastMessagesService} from '../../services/toast-messages.service';

@Component({
  selector: 'app-item-groups-factors',
  styleUrls: ['./item-groups-factors.component.scss'],
  templateUrl: './item-groups-factors.component.html'
})
export class ItemGroupsFactorsComponent implements OnInit {
  itemsGroup1: any;
  itemsGroup2: any;
  originalGroup2: any;
  originalMaterials: any;
  itemsMaterials: any;
  isLoading: boolean;

  constructor(private commonService: CommonService,
              private toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
  }

  public async ngOnInit(): Promise<any> {
    await this.initItemsGroup1();
    await this.initItemsGroup2();
    await this.initItemsMaterials();
    this.isLoading = false;
  }

  async initItemsGroup1() {
    try {
      this.itemsGroup1 = await this.commonService.getSimpleList(`agreement/items_group1`);
      for (const item of this.itemsGroup1) {
        item.originalValue = item.mark_up;
        item.originalVat = item.vat;
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initItemsGroup2() {
    try {
      this.itemsGroup2 = await this.commonService.getSimpleList(`agreement/items_group2`);
      for (const item of this.itemsGroup2) {
        item.originalValue = item.mark_up;
      }
      this.originalGroup2 = this.itemsGroup2;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async initItemsMaterials() {
    try {
      this.itemsMaterials = await this.commonService.getSimpleList(`agreement/items_material`);
      for (const item of this.itemsMaterials) {
        item.originalValue = item.mark_up;
      }
      this.originalMaterials = this.itemsMaterials;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async updateValue(group: number, item: any) {
    try {
      if (item.originalValue !== item.mark_up) {
        const model = {
          item: group,
          id: item.id,
          mark_up: item.mark_up
        };
        await this.commonService.updateObject(`agreement/items`, model);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  search(group: number, event: any) {
    if (event.keyCode === 13) {
      if (group === 1) {
        this.itemsGroup1.filter = event.target.value.trim().toLowerCase();
      }

      if (group === 2) {
        const value = +event.target.value;
        if (!value) {
          this.itemsGroup2 = this.originalGroup2;
        } else {
          const group1Items = this.itemsGroup1.filter(item => item.alternate_id === value.toString());
          let id;
          if (group1Items.length > 0) {
            id = group1Items[0].id;
            this.itemsGroup2 = this.originalGroup2.filter(item => item.group1_id === id);
          } else {
            this.itemsGroup2 = [];
            this.toastMessagesService.toastErrorMessage('Δεν βρέθηκε ο κωδικός της αναζήτησής σας');
          }
        }
      }

      if (group === 3) {
        const value = event.target.value;
        if (value !== '') {
          const group2Items = this.originalGroup2.filter(item => item.alternate_id.toLowerCase() === value.toString().toLowerCase());
          let id;
          if (group2Items.length > 0) {
            id = group2Items[0].id;
            this.itemsMaterials = this.originalMaterials.filter(item => item.group2_id === id);
          } else {
            this.itemsMaterials = [];
            this.toastMessagesService.toastErrorMessage('Δεν βρέθηκε ο κωδικός της αναζήτησής σας');
          }
        } else {
          this.itemsMaterials = this.originalMaterials;
        }
      }
    }
  }

  async updateVat(group: number, item: any) {
    try {
      if (item.originalVat !== item.vat) {
        const model = {
          item: group,
          id: item.id,
          vat: item.vat
        };
        await this.commonService.updateObject(`agreement/items`, model);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async updateIsActivate(group: number, item: any) {
    try {
      const model = {
        item: group,
        id: item.id,
        is_active: item.is_active ? 1 : 0
      };

      await this.commonService.updateObject(`agreement/items`, model);

    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }
}
